<template>
  <div>
    <layout-detail>
      <template slot="left">
        <div class="list-search-bar-container">
          <source-select-box
            v-model="pgData"
            collectionUrl="/user/collect?tabValue=standard"
            defaultFileType=""
            :fileTypes="fileTypes"
            @search="searchHandler"
            @fileTypeChange="fileTypeChange"
            :visitlocation="'个人中心-我的收藏'"
          >
          </source-select-box>
        </div>

        <div class="left-list" v-loading="pageLoading">
          <layout-card>
            <div v-if="tableData.length">
              <list-item
                class="item"
                v-for="(item, index) in tableData"
                :key="index"
                :data="item"
                :action="`${$store.state.api.baseWebUrl}/yzkj/standard/detail`"
                collectType="8"
                retype="standard"
                v-czc="[
                  '标准规范',
                  '点击列表',
                  '政策法规列表',
                  index + 1,
                  `standard-list-standardList`,
                ]"
              >
              </list-item>
            </div>

            <empty-list v-else>
              <span>暂无数据</span>
            </empty-list>
            <my-pagination
              ref="page"
              v-model="tableData"
              :action="`${$store.state.api.baseWebUrl}/yzkj/standard/search`"
              :loading.sync="pageLoading"
              :search="pgData"
              @currentChange="currentChange"
            ></my-pagination>
          </layout-card>
        </div>
      </template>

      <template slot="right">
        <img
          src="@/assets/images/watch/1.png"
          alt=""
          style="margin-bottom: 10px; border-radius: 5px"
        />

        <layout-card class="ceiling">
          <template slot="head"> 搜索热榜 </template>

          <section-hot
            :mdData="hotData"
            action="/yzkj/standard/recentList"
            type="standard"
          />
        </layout-card>
      </template>
    </layout-detail>
  </div>
</template>

<script>
import CONFIG_PROJECT from "@config/project";

import SearchBar from "@components/sys/list-search-bar-item";
import SourceSelectBox from "../library/components/source-select-box.vue";

import EmptyList from "@components/sys/empty-list";

import ListItem from "./components/list-item";
import SectionHot from "../library/sections/section-hot";

import LayoutDetail from "@components/sys/layout-detail";
import LayoutCard from "@components/sys/layout-card";
import loadList from "../library/components/loadList.vue";

import appNode from "@js/app-node";
import Ceiling from "@js/Ceiling";

export default {
  head: {
    title: `标准规范·${CONFIG_PROJECT.title}`,
  },
  components: {
    LayoutDetail,
    LayoutCard,
    ListItem,
    SectionHot,
    SearchBar,
    SourceSelectBox,
    EmptyList,
    loadList,
  },
  async asyncData(context) {
    let [fileTypes] = await Promise.all([
      appNode.ssrReq
        .call(context, `${context.store.state.api.baseWebUrl}/yzkj/dict/treeList`, {
          dictCode: "standard_type",
        })
        .then((data) => {
          return [
            {
              dictCode: "",
              dictName: "全部",
            },
            ...data,
          ];
        }),
    ]);

    return {
      fileTypes,
    };
  },
  data: () => ({
    pgData: {
      pageIndex: 1,
      pageSize: 10,
      sortOrder: "ASC",
      sourceStr: "",
      title: "",
      releaseDept: "",
    },
    fileType: "latestNews",
    sourceType: "",
    defaultFileType: "",
    tableData: [],

    pageLoading: false,
    hotData: {
      category: "标准规范",
      action: "点击列表",
      label: "最近更新",
      nodeid: "standard-list-recentlyUpdate",
    },
  }),
  methods: {
    fileTypeChange(val, index) {
      this.pgData.releaseDept = val.dictName == "全部" ? "" : val.dictName;
      this.setCzc(["标准规范", "筛选", "咨询类型", index, "standard-select-fileType"]);

      this.searchHandler();
    },

    searchHandler() {
      if (this.$refs.page) {
        this.$refs.page.queryData();
      }
    },
    currentChange(val) {
      this.setCzc([
        "标准规范",
        "翻页",
        "文件列表",
        val.nowPage,
        "standard-page-standardList",
      ]);
    },
  },
  created() {
    this.$store.dispatch("analysis/updateHits", {
      visitlocation: "标准规范",
    });
  },
  mounted() {
    new Ceiling({
      el: document.querySelector(".ceiling"),
    });
    if (this.$route.query.title) {
      this.pgData.title = this.$route.query.title;
    }
    if (this.$route.query.fileType) {
      this.pgData.releaseDept = this.$route.query.fileType;
    }
    this.searchHandler();
  },
};
</script>

<style lang="scss" scoped>
.page {
  margin-top: 20px;
}

.item {
  & + .item {
    border-top: 1px solid #e7e7e7;
    margin-top: 0;
    padding-top: 20px;
  }
}

.left-list {
  min-height: 500px;
}
</style>
